module.exports = __webpack_public_path__ + "assets/img/touring-basic.310f1e27.png";